import moment from "moment-timezone";

// config default timezone
export const TZ_TH = "Asia/Bangkok";
moment.tz.setDefault(TZ_TH);

const thaiMonths = [
  "มกราคม",
  "กุมภาพันธ์",
  "มีนาคม",
  "เมษายน",
  "พฤษภาคม",
  "มิถุนายน",
  "กรกฎาคม",
  "สิงหาคม",
  "กันยายน",
  "ตุลาคม",
  "พฤศจิกายน",
  "ธันวาคม",
];
const thaiShortMonths = [
  "ม.ค.",
  "ก.พ.",
  "มี.ค.",
  "เม.ย.",
  "พ.ค.",
  "มิ.ย.",
  "ก.ค.",
  "ส.ค.",
  "ก.ย.",
  "ต.ค.",
  "พ.ย.",
  "ธ.ค.",
];
const thaiShortMonthMatchedEng = {
  jan: "ม.ค.",
  feb: "ก.พ.",
  mar: "มี.ค.",
  apr: "เม.ย.",
  may: "พ.ค.",
  jun: "มิ.ย.",
  jul: "ก.ค.",
  aug: "ส.ค.",
  sep: "ก.ย.",
  oct: "ต.ค.",
  nov: "พ.ย.",
  dec: "ธ.ค.",
};
export const getThaiShortMonthByEng = (engShort) => {
  return thaiShortMonthMatchedEng[engShort?.toLowerCase()];
};

const defaultOptions = {
  format: "D M YYYY",
  // regMonth: /\s+(\d+)\s+/,
  short: false,
};
export const DateFormat_1 = { format: "D/M/YYYY", regMonth: /\/(\d+)\//, short: false };
export const DateFormat_2 = { format: "D/M/YYYY HH:mm", regMonth: /\/(\d+)\//, short: false };
export const DateFormat_3 = { format: "D/M/YY", short: false };
export const DateFormat_4 = { format: "D/MM/YYYY", short: false };
export const DateFormat_5 = { format: "DD M YYYY", regMonth: /\s+(\d+)\s+/, short: true };
export const DateFormat_6 = { format: "M YY", regMonth: /(\d+)\s+/, short: true };
export const DateFormat_7 = { format: "DD/MM/YY", short: false };
export const DateFormat_8 = { format: "DD/MM/YYYY", short: false };

export const convertToThaiFormat = (date, options = {}) => {
  if (!date) return date;
  const { format, short, regMonth } = { ...defaultOptions, ...options };
  const months = short ? thaiShortMonths : thaiMonths;
  //* Requirement: use christian year all over project
  // const thaiDate = moment(date).add(buddhaYear ? 543 : 0, 'year').format(format)
  const thaiDate = moment(date).format(format);
  return !regMonth ? thaiDate : thaiDate.replace(regMonth, (_, month) => ` ${months[month - 1]} `);
};

export const convertDateStrToThai = (date) => {
  if (!date) return date;

  return date.replace(/(\d+)(\W+)(\d+)\W+(\d+)/, (_, month, sep, day, year) => {
    return `${day}${sep}${month}${sep}${+year > 100 ? +year + 543 : +year + 43}`;
  });
};

export const convertToEngFormat = (date, format = "D MMMM YYYY") => {
  if (!date) return date;
  return moment(date).format(format);
};

export function getDateRange(startDate, endDate) {
  const start = moment(startDate);
  const end = moment(endDate);
  if (start.month() === end.month()) {
    const startStr = start.format("D");
    const endStr = convertToThaiFormat(end, {
      regMonth: /\s+(\d+)\s+/,
      short: true,
    });
    return `${startStr} - ${endStr}`;
  } else {
    const startStr = convertToThaiFormat(start, {
      format: "D M",
      regMonth: /\s+(\d+)/,
      short: true,
    });
    const endStr = convertToThaiFormat(end, {
      regMonth: /\s+(\d+)\s+/,
      short: true,
    });
    return `${startStr} - ${endStr}`;
  }
}
